<ng-container thr-parent-form>
    <div class="row align-items-end">
        <div class="col-12 col-md-6 col-lg-5 col-xl-6" *ngIf="!owner">
            <label>{{ 'form.participant-type'|translate }}</label><br>
            <mat-radio-group [name]="prefix + 'Nature'" [(ngModel)]="shareHolder.nature" (ngModelChange)="onNatureChange($event)" [required]="true" [disabled]="isDisabled">
                <div class="row mb-3 mb-sm-4">
                    <div class="col-6 col-md-5">
                        <mat-radio-button [name]="prefix + 'Natural'" color="blue-gray" [value]="Nature.NATURAL">
                            {{ 'form.natural'|translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-md-5">
                        <mat-radio-button [name]="prefix + 'Legal'" color="blue-gray" [value]="Nature.COMPANY">
                            {{ 'form.legal'|translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
        <div class="col-12 col-lg-7 col-xl-6" *ngIf="!shareHolder.isLegalPerson">
            <div class="row mb-3 mb-sm-4">
                <div class="col-12 col-sm-auto mb-4 mb-sm-0 mb-lg-2 mr-sm-4">
                    <mat-slide-toggle [name]="prefix + 'IsSpanish'" color="blue-gray" labelPosition="before" [disabled]="isDisabled" [(ngModel)]="shareHolder.isSpanish">
                        {{ 'form.you-are-spanish'|translate }}
                    </mat-slide-toggle>
                </div>
                <div class="col-12 col-sm-auto">
                    <mat-slide-toggle [name]="prefix + 'IsResident'" color="blue-gray" labelPosition="before" [disabled]="isDisabled" [(ngModel)]="shareHolder.isResident">
                        {{ 'form.you-are-resident'|translate }}
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-8" *ngIf="shareHolder.isLegalPerson">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input [name]="prefix + 'Name'" matInput [placeholder]="owner ? ('form.fullname-shareholder-legal'|translate) : ('form.fullname-shareholder'|translate)" required [disabled]="isDisabled" [(ngModel)]="shareHolder.name" #nameCtrl="ngModel">
                <mat-error *ngIf="nameCtrl.hasError('required')">
                    {{ 'form.validation.required'|translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-4" *ngIf="!shareHolder.isLegalPerson">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input [name]="prefix + 'Name'" matInput [placeholder]="owner ? ('form.name-shareholder-legal'|translate) : ('form.name-shareholder'|translate)" required [disabled]="isDisabled" [(ngModel)]="shareHolder.name" #nameCtrl="ngModel">
                <mat-error *ngIf="nameCtrl.hasError('required')">
                    {{ 'form.validation.required'|translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-4" *ngIf="!shareHolder.isLegalPerson">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input [name]="prefix + 'Surname'" matInput [placeholder]="owner ? ('form.surname-shareholder-legal'|translate) : ('form.surname-shareholder'|translate)" required [disabled]="isDisabled" [(ngModel)]="shareHolder.surname" #surnameCtrl="ngModel">
                <mat-error *ngIf="surnameCtrl.hasError('required')">
                    {{ 'form.validation.required'|translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select [name]="prefix + 'Citizenship'" [placeholder]="shareHolder.isLegalPerson ? ('form.country'|translate) : ('form.citizenship'|translate)" required [disabled]="isDisabled || shareHolder.isSpanish" [(ngModel)]="shareHolder.citizenship" #citizenCtrl="ngModel">
                    <ng-template ngFor let-country [ngForOf]="countries">
                        <mat-option [value]="country.id.value" *ngIf="(!shareHolder.isSpanish && country.id.value !== 'ES') || (shareHolder.isSpanish)">
                            {{ country.name }}
                        </mat-option>
                    </ng-template>
                </mat-select>
                <mat-error *ngIf="citizenCtrl.hasError('required')">
                    {{ 'form.validation.required'|translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select [name]="prefix + 'DocumentType'" [placeholder]="'form.document'|translate" [disabled]="isDisabled" [(ngModel)]="shareHolder.docType">
                    <ng-template ngFor let-type [ngForOf]="shareHolder.allowedDocTypes">
                        <mat-option [value]="type">{{ 'form.document-types.' + type|translate }}</mat-option>
                    </ng-template>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <thr-full-data-input-document [prefix]="prefix" [docType]="shareHolder.docType" [isDisabled]="isDisabled" [value]="shareHolder.docId" (valueChange)="shareHolder.docId = $event"></thr-full-data-input-document>
        </div>
        <div class="col-12 col-sm-6">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'form.indicates-participation'|translate }}
            </h3>
            <div class="d-flex flex-nowrap align-items-center mb-4">
                <div class="flex-grow-0 flex-shrink-0 mr-2">{{ min }}%</div>
                <div class="flex-grow-1 flex-shrink-1">
                    <mat-slider [name]="prefix + 'Percentage'" class="full-width" thumbLabel required [min]="min" [max]="max" [step]="1" [disabled]="isDisabled" [(ngModel)]="shareHolder.percentage"></mat-slider>
                </div>
                <div class="flex-grow-0 flex-shrink-0 ml-2">{{ max }}%</div>
            </div>
        </div>
    </div>
</ng-container>